export default "__VITE_ASSET__BlcCVv$t__"